import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { updateArrayInclusion } from '../../../../global/common/sorting';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import DataPaste from '../../../../global/components/pasting/DataPaste';
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { matchUpdateTypes } from '../../cnr/reducers/SportsSeasonReducer';
import { sportsHelpers } from '../../cnr/reducers/reducerHelpers/sportsHelpers';
import MatchHeader from '../../create/MatchHeader';
import MatchForm from './MatchForm';
import MatchPlayoffPending from './MatchPlayoffPending';
import { _allowUpdate_local } from '../../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate';

const MatchDetailsUpdate = (props) => {

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext
  const { teams_info, matches_info, sportPermissions } = sportsSeason_state ?? {}
  const { matches, matches_playoffs } = matches_info ?? {}
  const { teams } = teams_info ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { matchDataUpdates, newMatchDate, match_true } = sportsMatch_state ?? {}

  // sportsEditMatchContext
  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state, sportsEditMatch_handlers } = sportsEditMatchContext ?? {}
  const { matchPendingUpdate, updating, match_edit } = sportsEditMatch_state ?? {}
  const { matchUpdateType } = matchPendingUpdate ?? {}

  const { handle_updateMatch } = useMatchUpdate()

  const match_actual = match_true ? match_true : match_edit
  const { _itemKey } = match_actual ?? {}

  console.log('match_actual', match_actual)

  const _updateStatus = _allowUpdate_local && sportPermissions.any && sportPermissions.parentKeySportsData ? true : false

  // eslint-disable-next-line 
  const [matchReady, setMatchReady] = useState()
  const [winnerMatches, setWinnerMatches] = useState()

  useEffect(() => {
    switch (matchUpdateType) {
      case matchUpdateTypes.updatePendingMatch:
        const pendings = {
          levelMatchUpdates: {},
          matchWinners: {},
          matchLosers: {},
          results: {},
        }
        sportsHelpers.getPendingMatchInfo(match_actual, matches_playoffs, pendings, teams)
        setWinnerMatches(pendings.matchWinners)
        sportsEditMatch_handlers.handleSet_matchDataUpdates(pendings.levelMatchUpdates)
        break;
      case matchUpdateTypes.updatePrePendingMatch:
        const { data_match } = sportsHelpers.getPrePendingMatches(match_actual, matches_playoffs)
        sportsEditMatch_handlers.handleSet_matchDataUpdates(data_match)
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);


  const [selectedMatchKeys, setSelectedMatchKeys] = useState([])

  const handleItemData = (itemData) => sportsEditMatch_handlers.handleCreate_matchesFromList({ itemData, teams, matches })

  const handleCommit = () => {
    const cb = () => {
      sportsEditMatch_handlers.handleStopUpdate()
      sportsSeason_handlers.handleUpdate_sportsSeasonTs()
    }

    switch (matchUpdateType) {
      case matchUpdateTypes.openDatabase:
        break;
      default:
      // nothing
    }

    const { _matchCollectionKey, _itemKey, isPlayoff } = match_edit
    const prefix = isPlayoff ? 'playoffMatch' : 'match'
    const currentLevelMatches = {
      [_matchCollectionKey]: {
        [prefix + '.' + _itemKey]: match_edit
      }
    }
    sportsEditMatch_handlers.handleStartUpdate()
    handle_updateMatch({ matchPendingUpdate, match_edit, match_true, callback: cb })
    // sportsEditMatch_handlers.handleUpdate_match(cb)
  }

  const handleSelectedMatchKeys = (matchKey) => {
    const _selectedMatchKeys = [...selectedMatchKeys]
    updateArrayInclusion(_selectedMatchKeys, matchKey)
    setSelectedMatchKeys(_selectedMatchKeys)
  }

  const optsList = []
  if (teams) {
    const teamsS = _.sortBy(teams, 'name')
    teamsS.forEach(team => {
      optsList.push(
        {
          key: team.id,
          value: team.id,
          text: team.name
        }
      )
    })
  }

  const form_details = () => <MatchForm shows={{ showDate: true, showTeams: false, showLocation: true }} setMatchReady={setMatchReady} />
  const form_fullDetails = () => <MatchForm shows={{ showDate: true, showTeams: true, showLocation: true, showLevel: true }} setMatchReady={setMatchReady} />
  const form_results = () => <DataPaste handleItemData={handleItemData} />

  const match_pending = () => {
    if (winnerMatches) {
      return <div>
        <MatchPlayoffPending matches={winnerMatches} handleSelectedMatchKeys={handleSelectedMatchKeys} selectedMatchKeys={selectedMatchKeys} />
        <div>{JSON.stringify(matchDataUpdates)}</div>
      </div>
    }
  }

  const match_prePending = () => {
    if (matchDataUpdates) {
      return <div>
        <div>{JSON.stringify(matchDataUpdates)}</div>
      </div>
    }
  }

  const pending = () => {

    let content = 'Confirmation of Action: ' + _.startCase(matchUpdateType) + '?'

    switch (matchUpdateType) {
      case matchUpdateTypes.updateScore:
        if (matchPendingUpdate.realtimeMatch && matchPendingUpdate.realtimeMatch.currentResults) {
          content += ' (' + matchPendingUpdate.realtimeMatch.currentResults.scoreDisplays.full + ')?'
        }
        break;
      case matchUpdateTypes.updateMatchDayMatch:
        content = 'Update Match Day Match?'
        break;
      case matchUpdateTypes.updatePendingMatch:
        content = match_pending()
        break;
      case matchUpdateTypes.updatePrePendingMatch:
        content = match_prePending()
        break;
      case matchUpdateTypes.updateMatchDetails:
        content = form_details()
        break;
      case matchUpdateTypes.updateFullMatchDetails:
        content = form_fullDetails()
        break;
      case matchUpdateTypes.updateMatchListResults:
        content = form_results()
        break;
      case matchUpdateTypes.confirmMatchDate:
        content += 'Update Match Date? (' + newMatchDate + ')?'
        break;
      case matchUpdateTypes.updateGsScore:
        content += 'Update GS Score?'
        break;
      default:
        break;
    }

    const isDisabled = () => {
      switch (matchUpdateType) {
        case matchUpdateTypes.updatePendingMatch:
          return matchDataUpdates && Object.keys(matchDataUpdates).length > 0 ? false : true
        case matchUpdateTypes.deleteMatch:
          return false
        default:
          return false
      }
    }

    const header = () => <MatchHeader />

    const footer = () => <UiSaveButtons
      save={{ oc: handleCommit, caption: _.startCase(matchUpdateType), icon: 'check', color: _updateStatus && !isDisabled() ? 'green' : 'olive', disabled: isDisabled() }}
    />

    return <Wrapper
      header={header()}
      content={content}
      footer={footer()}
      wrapperType={wrapperTypes.padded}
      css={{ container: 'app-dark-mode' }}
    />
  }

  const fullPageWrapper = () => <FullPageWrapper
    content={pending()}
    topperCaption={_.startCase(matchUpdateType)}
    topperCaption2={_itemKey}
    updating={updating}
    handleCancel={props.handleCancel}
  />

  return fullPageWrapper()
}

export default MatchDetailsUpdate